import { useStyletron } from 'baseui';
import { HiOutlineOfficeBuilding } from 'react-icons/hi'
import { OverviewPanelWrapper } from '../../../components/OverviewPanelWrapper'
import { OperatorPanel as Location } from '../../../Utils/Location'

const CreatePanel = (props: any) => {
    const [, theme] = useStyletron();
    return (
        <OverviewPanelWrapper small={false} icon={<HiOutlineOfficeBuilding size='100%' color={theme.colors.backgroundPrimary}></HiOutlineOfficeBuilding>} {...props}>
            <Location longitude={15.721675585148244} latitude={47.095477358610665} width='250px' height='200px' title={'Building 1'} ></Location>
        </OverviewPanelWrapper>
    )
}

export default CreatePanel